import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MacAddressRoutingModule } from './mac-address-routing.module';
import { ModalService } from './services/modal.service';
import { SnackBarService } from './services/snackbar.service';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MacAddressRoutingModule,
  ],
  providers: [
    ModalService,
    SnackBarService
  ]
})
export class MacAddressModule { }
